// Build the copy-paste embed snippet for a campaign's capture form. The form is
// served by GET {base}/c/{orgHash}/form/{campaignId}/form, which injects the
// form + wires the (CORS-enabled, absolute-action-URL) subscribe.
//
// baseUrl must be absolute: the snippet runs on the customer's site, where a
// relative src resolves against their origin and 404s.
export function buildEmbedSnippet(baseUrl, orgHash, campaignId) {
  const base = (baseUrl || "").replace(/\/+$/, ""); // trim trailing slashes
  if (!base || !orgHash || !campaignId) {
    return "";
  }
  return `<script src="${base}/c/${orgHash}/form/${campaignId}/form"></script>`;
}
